exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".panel-group[data-v-2fa79ba1],.panel[data-v-2fa79ba1]{margin-bottom:0}.xxxuser-client[data-v-2fa79ba1]{border:0 solid #d3d3d3;box-shadow:0 0 3px grey;margin-top:20px}h2 .fa[data-v-2fa79ba1]{padding-right:6px;color:#337ab7}.btn-default .fa[data-v-2fa79ba1]{padding-right:0;color:#337ab7}.cc-kombox-item[data-v-2fa79ba1]{border-bottom:1px solid #d3d3d3;padding-top:5px;padding-bottom:5px}.cc-kombox-item[data-v-2fa79ba1]:hover,.cc-memo-item[data-v-2fa79ba1]:hover{background-color:#fcf8e3}.cc-kombox-list[data-v-2fa79ba1],.cc-memo-list[data-v-2fa79ba1]{height:100%;overflow:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-2fa79ba1&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/UserCallCenter.vue
// module id = 195
// module chunks = 0